const ALGOLIA_INDEX_PRODUCTS_CREATED_AT_ASC = 'products_createdAt_asc';
const ALGOLIA_INDEX_PRODUCTS_CREATED_AT_DESC = 'products_createdAt_desc';
const ALGOLIA_INDEX_PRODUCTS_PRICE_ASC = 'products_price_asc';
const ALGOLIA_INDEX_PRODUCTS_PRICE_DESC = 'products_price_desc';
const ALGOLIA_INDEX_PRODUCTS_DISCOUNT_TIMESTAMP_DESC = 'products_discountTimestamp_desc';

const buildAlgoliaFilters = restParams => {
  const filterMap = {
    pub_categoryLevel1: value => `publicData.categoryLevel1:${value}`,
    pub_categoryLevel2: value => `publicData.categoryLevel2:${value}`,
    pub_categoryLevel3: value => `publicData.categoryLevel3:${value}`,
    pub_Condition: value => {
      const conditions = value.split(',').map(condition => condition.trim());
      if (conditions.length === 1) {
        return `publicData.Condition:${conditions[0]}`;
      }
      return `(${conditions.map(condition => `publicData.Condition:${condition}`).join(' OR ')})`;
    },
    pub_tags: value => {
      const [type, tagsString] = value.split(':');
      const tagsArray = tagsString.split(',').map(tag => tag.trim());

      if (tagsArray.length === 0) {
        return ''; // Or handle as an error, depending on requirements
      }

      if (tagsArray.length === 1) {
        return `publicData.tags:${tagsArray[0]}`;
      }

      const joinOperator = type === 'has_all' ? ' AND ' : ' OR ';
      return `(${tagsArray.map(tag => `publicData.tags:${tag}`).join(joinOperator)})`;
    },
    pub_discountAvailable: value => `publicData.discountAvailable:${value}`,
    price: value => {
      const [min, max] = value.split(',');
      return `price.amount:${min * 100} TO ${max * 100}`;
    },
    pub_Width: value => {
      const [min, max] = value.split(',');
      return `publicData.Width:${min} TO ${max}`;
    },
    pub_Height: value => {
      const [min, max] = value.split(',');
      return `publicData.Height:${min} TO ${max}`;
    },
    pub_Depth: value => {
      const [min, max] = value.split(',');
      return `publicData.Depth:${min} TO ${max}`;
    },
  };

  const filters = ['state:published', 'currentStock > 0'];

  Object.entries(restParams).forEach(([key, value]) => {
    if (filterMap[key]) {
      filters.push(filterMap[key](value));
    }
  });

  return filters.length > 0 ? filters.join(' AND ') : null;
};

const getAlgoliaIndexName = sort => {
  const SORT_TO_INDEX = {
    price: ALGOLIA_INDEX_PRODUCTS_PRICE_DESC,
    '-price': ALGOLIA_INDEX_PRODUCTS_PRICE_ASC,
    '-createdAt': ALGOLIA_INDEX_PRODUCTS_CREATED_AT_ASC,
    pub_discountTimestamp: ALGOLIA_INDEX_PRODUCTS_DISCOUNT_TIMESTAMP_DESC,
  };

  return SORT_TO_INDEX[sort] || ALGOLIA_INDEX_PRODUCTS_CREATED_AT_DESC;
};

export { buildAlgoliaFilters, getAlgoliaIndexName };
